import $http from "@/services/Http";
import { responseToClass } from "@/api/lib";
import Protocol from "@/models/Protocol";
import { prefix } from "@/api/config";
import ImportFormRequest from "@/forms/requests/project/protocol/ImportFormRequest";
import { AxiosPromise } from "axios";

export function list(projectId: string): AxiosPromise<Protocol[]> {
  return $http
    .get(`${prefix}/projects/${projectId}/protocols`)
    .then((response) => responseToClass(Protocol, response));
}

export function import_(projectId: string, data: ImportFormRequest) {
  return $http.post(`${prefix}/projects/${projectId}/import-protocols`, data);
}
